import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SCAN_ANALYSIS = 'GET_SCAN_ANALYSIS';
export const GET_SCAN_ANALYSIS_SUCCESS = 'GET_SCAN_ANALYSIS_SUCCESS';
export const GET_SCAN_ANALYSIS_FAILURE = 'GET_SCAN_ANALYSIS_FAILURE';

// Action Creators
export const getScanAnalysis = () => ({
  type: GET_SCAN_ANALYSIS,
});

export const getScanAnalysisSuccess = (users) => ({
  type: GET_SCAN_ANALYSIS_SUCCESS,
  payload: users,
});

export const getScanAnalysisFailure = (error) => ({
  type: GET_SCAN_ANALYSIS_FAILURE,
  payload: error,
});

// Thunk Function
export const getScanAnalysisCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getScanAnalysis());
    try {
      const response = await getMethodWithToken(url.scanAnalysis + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getScanAnalysisSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getScanAnalysisFailure(error?.message));
    }
  };
};
